import { USER_TYPE } from 'libs/constants';

export const notificationOptions: UserMenuOptions[] = [
  {
    name: 'Special Offers',
    href: '/offers/available-offers',
    itemKey: 'unredeemedOffers',
    unAcknowledgedKey: 'hasUnacknowledgedUnredeemedOffers',
    userTypes: [USER_TYPE.consumer]
  },

  {
    name: 'Free Minutes',
    href: '/offers/advisor-offers',
    itemKey: 'unusedFreeMinutes',
    unAcknowledgedKey: 'hasUnacknowledgedUnusedFreeMinutes',
    userTypes: [USER_TYPE.consumer],
    divider: true
  },
  {
    name: 'Alert Me List',
    href: '/alert-me',
    userTypes: [USER_TYPE.consumer]
  },
  {
    name: 'Mail',
    href: '/Mail/Inbox.aspx?Subroutine=mail&SubroutineParams=mode%3d3&ReturnURL=&CancelURL=',
    itemKey: 'unreadMail',
    unAcknowledgedKey: 'hasUnacknowledgedMail',
    userTypes: [USER_TYPE.consumer, USER_TYPE.advisor]
  },
  {
    name: 'Ping',
    href: '/app/#/direct-messages',
    itemKey: 'unreadPings',
    unAcknowledgedKey: 'hasUnacknowledgedPings',
    userTypes: [USER_TYPE.consumer, USER_TYPE.advisor]
  },
  {
    name: 'Leave Feedback',
    href: '/Feedback/Summary',
    itemKey: 'outstandingFeedback',
    unAcknowledgedKey: 'hasUnacknowledgedOutstandingFeedback',
    userTypes: [USER_TYPE.consumer]
  },
  {
    name: 'Arranged Conversations',
    href: '/app/#/arranged-conversations',
    itemKey: 'arrangedConversations',
    unAcknowledgedKey: 'hasUnacknowledgedArrangedConversations',
    userTypes: [USER_TYPE.consumer, USER_TYPE.advisor]
  }
];

export const userProfileOptions: UserMenuOptions[] = [
  {
    name: 'My Keen',
    href: '/myaccount',
    dividerBelow: true,
    userTypes: [USER_TYPE.consumer, USER_TYPE.advisor]
  },
  {
    name: 'Payment Information',
    href: '/myaccount/payment-info',
    userTypes: [USER_TYPE.consumer, USER_TYPE.advisor]
  },
  {
    name: 'Personal Information',
    href: '/MyAccount/UpdatePersonalInfoStarter.aspx',
    userTypes: [USER_TYPE.consumer, USER_TYPE.advisor]
  },
  {
    name: 'Transaction Details',
    href: '/myaccount/payment-info/transaction-details',
    userTypes: [USER_TYPE.consumer, USER_TYPE.advisor]
  },
  {
    name: 'Chat Transcripts',
    href: '/ChatTranscripts/Summary',
    userTypes: [USER_TYPE.consumer]
  },
  {
    name: 'Favorite Advisors',
    href: '/MyAccount/MyFavoriteAdvisors',
    userTypes: [USER_TYPE.consumer]
  },
  {
    name: 'My Customers',
    href: '/app/#/myaccount/customers',
    userTypes: [USER_TYPE.advisor]
  },
  {
    name: 'My Feedback',
    href: '/app/#/myaccount/feedback',
    userTypes: [USER_TYPE.advisor]
  },
  {
    name: 'My Listings',
    href: '/account/account.asp',
    userTypes: [USER_TYPE.advisor]
  },
  {
    name: 'Help',
    href: `${process.env.NEXT_PUBLIC_KEEN_HELP}/hc/en-us`,
    userTypes: [USER_TYPE.consumer, USER_TYPE.advisor]
  },
  {
    name: 'Sign Out',
    href: '/login/logout',
    dividerAbove: true,
    userTypes: [USER_TYPE.consumer, USER_TYPE.advisor]
  }
];
